import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import Reveal from './Reveal';
import SectionHead from './SectionHead';
import CaseStudyCard from './CaseStudyCard';
import { caseStudies } from '../data/site';

const FeaturedWork = () => (
  <section className="section">
    <div className="container">
      <div className="section-head-row">
        <SectionHead
          eyebrow="Selected work"
          title="Built for real institutions and businesses"
        />
        <Link to="/work" className="text-link">
          View all projects <FiArrowRight />
        </Link>
      </div>
      <Reveal className="work-grid featured">
        {caseStudies.slice(0, 3).map((project, i) => (
          <CaseStudyCard key={project.title} project={project} featured={i === 0} />
        ))}
      </Reveal>
    </div>
  </section>
);

export default FeaturedWork;
